
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.512 16.315l.882 1.523c.183.321.447.573.756.757l3.15-5.453H0c0 .355.092.71.275 1.031l1.237 2.142z","fill":"#0066DA"}}),_c('path',{attrs:{"d":"M10 6.727L6.85 1.275a2.08 2.08 0 00-.756.756L.274 12.11c-.179.314-.274.67-.274 1.031h6.3L10 6.727z","fill":"#00AC47"}}),_c('path',{attrs:{"d":"M16.85 18.595a2.08 2.08 0 00.756-.756l.366-.63 1.753-3.036c.183-.32.275-.676.275-1.03h-6.3l1.34 2.634 1.81 2.818z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M10 6.727l3.15-5.452A2.014 2.014 0 0012.12 1H7.88c-.367 0-.722.103-1.03.275L10 6.727z","fill":"#00832D"}}),_c('path',{attrs:{"d":"M13.7 13.142H6.3l-3.15 5.453c.31.183.664.274 1.03.274H15.82c.366 0 .722-.103 1.03-.274l-3.15-5.453z","fill":"#2684FC"}}),_c('path',{attrs:{"d":"M16.816 7.071l-2.91-5.04a2.081 2.081 0 00-.756-.756L10 6.727l3.7 6.415h6.288c0-.355-.091-.71-.274-1.03L16.816 7.07z","fill":"#FFBA00"}})])
          )
        }
      }
    